/**
 * Build the time-ordered HR series used by every downstream module.
 * One canonical shape — `{ ts, bpm }[]` — so set, rest, and phase computations
 * all walk the same array.
 */
import type { FirehoseSampleEntry } from "@contract/types";

export interface HrPoint {
  ts: number;
  bpm: number;
}

export function buildHrSeries(samples: FirehoseSampleEntry[]): HrPoint[] {
  return samples
    .map((s) => ({
      ts: new Date(s.startDate).getTime(),
      bpm: s.value ?? 0,
    }))
    .filter((p) => p.bpm > 0)
    .sort((a, b) => a.ts - b.ts);
}
